module.exports = __webpack_public_path__ + "static/media/03_tn.d23b097f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/03_tn.jpg
// module id = 639
// module chunks = 0